// Colores base de la aplicación
export const DANGER_COLOR = '#dc3545';
export const SUCCESS_COLOR = '#56ca00';
export const PRIMARY_COLOR = '#9055FD';
export const PRIMARY_COLOR_SMOOTH = '#B586FF';
export const PRIMARY_COLOR_SMOOTH_SOFT = '#D5C5FB';
export const INFO_COLOR = '#66d1d1';
export const WARNING_COLOR = '#e2843c';